import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_b2ceecb0-da08-477c-bdbc-45b3f8bca466/artifacts/inshyz6k_PG%20New%20Logo%20%281%29.png';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Pathway', href: '/#pathway', sectionId: 'pathway' },
    { label: 'Deliverables', href: '/#deliverables', sectionId: 'deliverables' },
    { label: 'About', href: '/#about', sectionId: 'about' },
    { label: 'FAQs', href: '/#faqs', sectionId: 'faqs' },
    { label: 'Apply', href: '/sovereign-application', isPage: true },
  ];

  const handleNavClick = (e, link) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);

    // If it's a page link, navigate directly
    if (link.isPage) {
      navigate(link.href);
      window.scrollTo(0, 0);
      return;
    }

    // If we're on the home page, scroll to section
    if (location.pathname === '/') {
      const element = document.getElementById(link.sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      }
    } else {
      // If we're on another page, navigate to home first then scroll
      navigate('/');
      // Use setTimeout to allow navigation to complete
      setTimeout(() => {
        const element = document.getElementById(link.sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };

  return (
    <header className={`nav-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="flex items-center justify-between py-4">
          {/* Logo */}
          <a 
            href="/" 
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
              window.scrollTo(0, 0);
            }}
            className="flex items-center gap-3"
          >
            <img 
              src={LOGO_URL} 
              alt="Overflow Nation" 
              className="h-10 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavClick(e, link)}
                className="nav-link"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Desktop CTA */}
          <a
            href="https://wa.me/9172096199"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-flex btn-gold text-sm py-3 px-6"
          >
            Start on WhatsApp
          </a>

          {/* Mobile Menu Toggle */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-[var(--border-light)]">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link)}
                  className="nav-link py-2"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="https://wa.me/9172096199"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold text-sm py-3 px-6 text-center mt-4"
              >
                Start on WhatsApp
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navigation;
